import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '平台大全', path: '/category/all' },
    { label: '小说创作平台', path: '/category/novel' },
    { label: '免费平台', path: '/category/free' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '小说创作', path: '/category/novel' },
    { label: '博客写作', path: '/category/blog' },
    { label: '社交媒体', path: '/category/social' },
    { label: '专业写作', path: '/category/professional' },
    { label: '免费平台', path: '/category/free' },
  ],
  articles: [
    { label: '十大平台推荐', path: '/article/top-10-powen-platforms-2026' },
    { label: '新人积累读者攻略', path: '/article/new-author-reader-growth-guide' },
    { label: '流量变现全攻略', path: '/article/traffic-monetization-complete-guide' },
    { label: '免费平台大盘点', path: '/article/free-powen-platforms-roundup' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-xl font-bold font-heading text-background-50">
              Po文导航
            </span>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              精选优质原创内容发布平台，为创作者提供一站式推荐服务。涵盖注册教程、发布技巧、流量变现等全方位创作指南。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">平台分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">精选文章</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.articles.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2026 Po文导航 - 原创内容发布平台推荐. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="/about"
              className="text-sm text-foreground-500 hover:text-background-50 transition-colors"
            >
              联系我们
            </a>
            <a
              href="/about"
              className="text-sm text-foreground-500 hover:text-background-50 transition-colors"
            >
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}